import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { ConfiguracionGeneral, ConfiguracionGeneralInput } from '../../modelos/Configuracion';

export const configuracionService = {
  getByEmpresa: (empresaId: string): Promise<ApiResponse<ConfiguracionGeneral>> => {
    return httpClient.get('/configuraciones', { empresaId });
  },

  create: (data: ConfiguracionGeneralInput): Promise<ApiResponse<ConfiguracionGeneral>> => {
    return httpClient.post('/configuraciones', data);
  },

  update: (id: string, data: ConfiguracionGeneralInput): Promise<ApiResponse<ConfiguracionGeneral>> => {
    return httpClient.put(`/configuraciones/${id}`, data);
  },

  actualizarCobranzaAutomaticaPos: (
    id: string,
    data: { esCobranzaAutomaticaPos: boolean; medioPagoAutomaticoId?: string | null },
  ): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/cobranza-pos`, data);
  },

  actualizarInventario: (id: string, configuracionInventario: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/inventario`, { configuracionInventario });
  },

  actualizarInventarioUi: (id: string, inventarioUi: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/inventario-ui`, { inventarioUi });
  },

  actualizarConexionSunat: (id: string, conexionSunat: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/conexion-sunat`, { conexionSunat });
  },

  actualizarDatosTransportista: (id: string, datosTransportista: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/datos-transportista`, { datosTransportista });
  },

  actualizarEnvioCorreoPredeterminado: (id: string, envioCorreoPredeterminado: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/envio-correo`, { envioCorreoPredeterminado });
  },

  actualizarConfiguracionGeneral: (id: string, configuracionGeneral: string): Promise<ApiResponse<object>> => {
    return httpClient.patch(`/configuraciones/${id}/general`, { configuracionGeneral });
  },
};
